import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Layout from '../views/layout/Index'

Vue.use(VueRouter);

const load = (path) => {
  return () => import(`../views/${path}`);
}
const lazy = (p) => {
  const chunk = p.substring(0, p.indexOf('/')) || 'index'
  console.log('chunk:', p, chunk)
  return r => require([`@/views/${p}`], r)
}
const p = (a) => {
  const chunk = p.substring(0, p.indexOf('/')) || 'index'
  return `@/views/${p}`
}
const routes = [
  {
    path: "/about", name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  { path: "/review/:id", name: "orderReview", props: true, component: lazy('shop/OrderReview') },
  { path: "/login", name: "login", component: () => import(/* webpackChunkName: "login" */ "@/views/Login") },
  {
    path: "/", component: Layout, children: [
      { path: "order", name: "order", component: lazy('shop/OrderList'), meta: { title: '订单列表' } },
      { path: "order/:id", name: "orderDetail", props: true, component: lazy('shop/OrderDetail'), meta: {} },
      { path: '', name: 'home', component: () => import(`@/views/shop/Index`), props: true, meta: {} },
    ]
  },
  { path: "*", name: "404", component: () => import(/* webpackChunkName: "404" */ '@/views/NotFound') },
];

const vr = () => new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

const router = vr()
export default router;
